module.exports = __webpack_public_path__ + "img/kim-robertsen-p.d2b5041f.jpg";